import MarkdownPage from "../components/MarkdownPage";

export default function CookiePolicyPage() {
    return (
        <MarkdownPage
            title="Cookie Policy – CV Box"
            description="Learn how CV Box uses cookies to improve your experience."
            markdownFile="/content/cookies.md"
        />
    );
}